module.exports = __webpack_public_path__ + "static/media/icon.5d01b994.png";